import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import {
  dateDifferenceInDaysFromToday,
  useOnClickOutside
} from '../../../helpers/helperFunctions';
import { useWindowWide } from '../../../helpers/wideScreen';
import { LOGIN } from '../../../routes/routes';
import { UserInfoType } from '../../../types/loginTypes';
import { DashboardNav } from '../../../views/Dashboard/DashboardNav';
import { Menu } from '../BackofficeLayoutStyled';

interface DashboardNavDropdownType {
  menuIsOpen: boolean;
  userInfo: UserInfoType;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  refMenu: React.RefObject<HTMLDivElement>;
}

export const DashboardNavDropdown = ({
  menuIsOpen,
  userInfo,
  setMenuIsOpen,
  refMenu
}: DashboardNavDropdownType) => {
  const wide = useWindowWide(800);
  const location = useLocation();
  useEffect(() => {
    if (!wide && menuIsOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
  }, [menuIsOpen, wide]);

  useOnClickOutside(refMenu, () => menuIsOpen && setMenuIsOpen(false));

  useEffect(() => {
    setMenuIsOpen(false);
  }, [location.pathname]);

  return (
    <>
      <Menu isOpen={menuIsOpen} left width='500px' ref={refMenu}>
        <DashboardNav user={userInfo?.user} />
      </Menu>
    </>
  );
};
